/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWebp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M20 7.586V11h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM9.396 15.62l.697-2.407h.69l.727 2.379.548-2.593h.824l-.861 3.892h-.804l-.798-2.62-.754 2.62h-.804L8 13h.846zm6.49-1.914H14.19v.867h1.541v.706H14.19v.905h1.75v.707h-2.585V13h2.533zM17.909 13c.496 0 .86.084 1.092.252.235.168.353.428.353.781a.84.84 0 0 1-.294.653 1.115 1.115 0 0 1-.225.152c.15.046.275.112.375.196.207.168.31.407.31.717 0 .382-.13.667-.39.856-.26.19-.657.285-1.189.285h-1.397V13zm3.524 0c.478 0 .839.11 1.082.332.246.221.369.55.369.984 0 .29-.056.533-.166.729-.107.193-.27.339-.487.438-.215.1-.48.15-.798.15h-.562v1.259h-.83V13zm-4.086 3.249h.53c.274 0 .476-.043.605-.128.128-.086.193-.22.193-.401 0-.179-.065-.31-.193-.392-.129-.082-.33-.123-.605-.123h-.53zm3.524-2.57v1.275h.39c.286 0 .487-.048.605-.144.122-.1.183-.265.183-.494 0-.231-.061-.396-.183-.492-.118-.096-.319-.144-.604-.144zm-3.524.932h.407c.282 0 .48-.036.594-.107.117-.075.176-.2.176-.374a.497.497 0 0 0-.074-.29.404.404 0 0 0-.241-.155 1.697 1.697 0 0 0-.455-.048h-.407zM15 7h1.586L15 5.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileWebp as FileWebp };
